// src/components/AgeRestriction.js
import React, { useState, useEffect } from "react";
import "../styles/agerestriction.css";

const AgeRestriction = () => {
  const [showModal, setShowModal] = useState(false);
  const [rememberChoice, setRememberChoice] = useState(false);

  useEffect(() => {
    // Provjeri je li korisnik već odgovorio (prvo localStorage, zatim sessionStorage)
    const ageRestrictionLocal = localStorage.getItem("ageRestriction");
    const ageRestrictionSession = sessionStorage.getItem("ageRestriction");
    if (!ageRestrictionLocal && !ageRestrictionSession) {
      setShowModal(true);
    }
  }, []);

  const handleYes = () => {
    // Uvijek spremi u sessionStorage za trenutnu sesiju
    sessionStorage.setItem("ageRestriction", "confirmed");
    // Ako je checkbox checked, spremi i u localStorage za trajno pamćenje
    if (rememberChoice) {
      localStorage.setItem("ageRestriction", "confirmed");
    }
    setShowModal(false);
    // Dispatch custom event da CookieBanner zna da je age restriction potvrđen
    window.dispatchEvent(new CustomEvent("ageRestrictionConfirmed"));
  };

  const handleNo = () => {
    // Uvijek spremi u sessionStorage za trenutnu sesiju
    sessionStorage.setItem("ageRestriction", "denied");
    // Ako je checkbox checked, spremi i u localStorage za trajno pamćenje
    if (rememberChoice) {
      localStorage.setItem("ageRestriction", "denied");
    }
    // Možeš dodati redirect ili poruku
    alert("Žao nam je, ova stranica je dostupna samo osobama starijim od 18 godina.");
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <div className="age-restriction-overlay">
      <div className="age-restriction-modal">
        <h2 className="age-restriction-title">
          Imate li više od 18 godina?
        </h2>
        <div className="age-restriction-actions">
          <button
            className="age-restriction-btn age-restriction-btn--yes"
            onClick={handleYes}
          >
            Da
          </button>
          <button
            className="age-restriction-btn age-restriction-btn--no"
            onClick={handleNo}
          >
            Ne
          </button>
        </div>
        <div className="age-restriction-remember">
          <label className="age-restriction-checkbox">
            <input
              type="checkbox"
              checked={rememberChoice}
              onChange={(e) => setRememberChoice(e.target.checked)}
            />
            <span>Zapamti odabir</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default AgeRestriction;

